<template>
  <div class="bfc-market">
    <div class="hero">
      <h1>Efor Group</h1>
    </div>

    <div class="strip">
      <p>February 2022 <span>✹ </span> May 2022</p>
      <p class="index">005</p>
    </div>

    <div class="info">
      <div class="context">
        <h2>The context</h2>
        <p>
          EFOR is a consulting company specialized in Life Sciences, created in 2013.
          At the end of 2020 the EFOR group and CVO-EUROPE decided to join their strengths, their skills and their history to create the
          history to create the European leader in Life Sciences consulting.
        </p>
        <p>
          With more than 1,500 specialists, engineers, doctors and pharmacists, Efor Group aims to consolidate its leading position in Life Sciences Consulting by continuing its development.
        </p>
      </div>
      <div class="right-info">
        <div class="contribution">
          <h2>My contribution</h2>
          <p>
            My contributions to this project is mostly the website development.
            I was in charge of the wordpress theme development made from scratch with Laravel and animated with JS and GSAP.
          </p>
        </div>

        <div class="result">
          <h2>The result</h2>
          <p>
            We've made a Wordpress complex website with lots of pages and the client's expectations were entirely satisfied.
          </p>
          <a
              href="https://efor.pamplemousse.site/"
              target="_blank"
              rel="noopener noreferrer"
          >Visit the project right here.</a
          >
        </div>
      </div>
    </div>

    <div class="mockup-holder section2">
      <div class="mockup">
        <img
          src="../../assets/images/projects/efor.png"
          alt="the efor website ui design"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bfc-market {
  margin: 5rem 2rem;
  @media screen and (max-width: 800px) {
    margin: 0 1rem;
  }
}

h1 {
  font-size: 15vw;
  line-height: 100%;
  margin: 0;
  @media screen and (min-width: 1700px) {
    font-size: 25rem;
  }
  @media screen and (max-width: 800px) {
    font-size: 8rem;
  }
}

a {
  color: $blue;
  &:hover {
    text-decoration: underline;
  }
}

h2 {
  margin: 0;
  font-family: $font-body;
  color: $blue;
  font-size: 4rem;
  font-variation-settings: "wght" 400;
  font-weight: 400;
  @media screen and (max-width: 800px) {
    font-size: 3rem;
  }
}

.hero {
  height: 40vh;
  display: flex;
  align-items: flex-end;
}

.info {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
  p {
    padding: 1rem 0;
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
}
.context,
.right-info {
  width: 40%;
  @media screen and (max-width: 800px) {
    width: 100%;
  }
}

.strip {
  display: flex;
  justify-content: space-between;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
  p {
    padding: 0.5rem 0;
    font-size: 5rem;
    font-variation-settings: "wght" 300;
    @media screen and (max-width: 800px) {
      font-size: 2rem;
    }
  }
  .index {
    text-align: end;
  }
  span {
    color: $green;
  }
}

.mockup-holder {
  margin: 5rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.mockup {
  width: 50%;
  max-width: 100rem;
  img {
    width: 100%;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
  }
}
</style>

<script>
export default {
  name: "Efor",
};
</script>
